import Vue from 'vue'

const eventService = new Vue({
	methods: {
		toggleDropDown (dropDownId) {
			const targetElement = document.getElementById(dropDownId)
			if (targetElement && targetElement.classList &&
        targetElement.classList.contains('open')) {
				targetElement.classList.remove('open')
				targetElement.style.display = 'none'
			} else if (targetElement && targetElement.classList) {
				targetElement.classList.add('open')
				targetElement.style.display = 'block'
			}
		},
		accordionToggler (togglerId) {
			const panel = document.getElementById(togglerId)
			if (panel.style.display === 'block') {
				panel.style.display = 'none'
			} else {
				panel.style.display = 'block'
			}
		}
	}
})

export default eventService
